<template lang="html">
  <div id="" class="">
        <div class="row"  v-if="filtre">
          <div class="mt20">
            <input type="text" class="input_filtre" name="" placeholder="Filter name" v-model="filtre.filter_name">

          </div>

          <draggable
  :list="filtre.condition"
  item-key="id"
  ghost-class="ghost"
  >
  <template #item="{element , index}" >
            <div class="col-12 criteria" >
                          <button type="button" class="removeCriteria" @click="remove(index)" name="button">REMOVE</button>
              <div class="criteria_header">
                <span class="criteria_name">Criteria {{index + 1}} : {{element.taxonomy_label}}</span>

              </div>
              <div class="criteria_content">
                  <div class="criteria_values">
                    <div class="row" v-if="element.type == 'select'">
                        <div class="vselect_container col-12 col-lg-12" >
                          <div class="zone_input">
                            <div class="">
                              <span class="zone_input_name">Values</span>
                            </div>
                            <v-autocomplete v-model="element.values" :items="element.values_list" item-title="name" item-value="value" chips closable-chips multiple ></v-autocomplete>

                            </div>
                        </div>
                        <div class="vselect_container col-12 col-lg-6" >
                          <div class="zone_input">
                            <div class="">
                              <span class="zone_input_name">Operator</span>
                            </div>
                            <v-select v-model='element.operator' :items="['AND','OR']"/>
                            </div>
                        </div>
                        <div class="vselect_container col-12 col-lg-6" >
                          <div class="zone_input">
                            <div class="">
                              <span class="zone_input_name">Weight</span>
                            </div>
                          <input type="number" class="innopearl_input" v-model="element.weight"/>
                            </div>
                        </div>
                    </div>

                    <!-- <div class v-if="condition.type == 'number'">
                      <input type="number" v-model="condition.values"/>
                        <input type="number" v-model="condition.weight"/>
                    </div> -->
                    <div class="row" v-if="element.type == 'range'">
                      <div class="vselect_container  col-12 col-lg-4" >
                        <div class="zone_input">
                          <div class="">
                            <span class="zone_input_name">Value from</span>
                          </div>
                        <input type="number" class="innopearl_input" v-model="element.values[0]"/>
                          </div>
                      </div>
                      <div class="vselect_container  col-12 col-lg-4" >
                        <div class="zone_input">
                          <div class="">
                            <span class="zone_input_name">Value to</span>
                          </div>
                        <input type="number" class="innopearl_input" v-model="element.values[1]"/>
                          </div>
                      </div>
                      <div class="vselect_container  col-12 col-lg-4" >
                        <div class="zone_input">
                          <div class="">
                            <span class="zone_input_name">Weight</span>
                          </div>
                        <input type="number" class="innopearl_input" v-model="element.weight"/>
                          </div>
                      </div>


                    </div>


                    <div class="row" v-if="element.type == 'boolean'">
                      <div class="vselect_container  col-12 col-lg-6" >
                        <div class="zone_input">
                          <div class="">
                            <span class="zone_input_name">Value</span>
                          </div>
                            <v-select v-model='element.values'  :items="[{value:true,display:'YES'},{value:false,display:'NO'}]"  item-title="display"  item-value="value"/>
                          </div>
                      </div>
                      <div class="vselect_container  col-12 col-lg-6" >
                        <div class="zone_input">
                          <div class="">
                            <span class="zone_input_name">Weight</span>
                          </div>
                        <input type="number" class="innopearl_input" v-model="element.weight"/>
                          </div>
                      </div>

                    </div>


                    <div class="row" v-if="element.type == 'money'">
                      <div class="vselect_container  col-12 col-lg-6" >
                        <div class="zone_input">
                          <div class="">
                            <span class="zone_input_name">Min</span>
                          </div>
                        <input type="number" class="innopearl_input" v-model="element.values.min"/>
                          </div>
                      </div>
                      <div class="vselect_container  col-12 col-lg-6" >
                        <div class="zone_input">
                          <div class="">
                            <span class="zone_input_name">Max</span>
                          </div>
                        <input type="number" class="innopearl_input" v-model="element.values.max"/>
                          </div>
                      </div>
                      <div class="vselect_container  col-12 col-lg-6" >
                        <div class="zone_input">
                          <div class="">
                            <span class="zone_input_name">Currency</span>
                          </div>
                          <select class="moneyEntryInput innopearl_input input_filtre" name=""  v-model="element.values.unit">
                            <option value="M">M</option>
                          </select>
                          </div>
                      </div>
                      <div class="vselect_container  col-12 col-lg-6" >
                        <div class="zone_input">
                          <div class="">
                            <span class="zone_input_name">Weight</span>
                          </div>
                          <input type="number" class="innopearl_input" v-model="element.weight"/>

                          </div>
                      </div>
                      <!-- <div class="vselect_container  col-12 col-lg-6" >
                        <div class="zone_input">
                          <div class="">
                            <span class="zone_input_name">Unit</span>
                          </div>
                        <input type="number" class="innopearl_input" v-model="element.values.unit"/>
                          </div>
                      </div> -->

                      <!-- <div class="vselect_container  col-12 col-lg-6" >
                        <div class="zone_input">
                          <div class="">
                            <span class="zone_input_name">Currency</span>
                          </div>
                          <select class="moneyEntryInput innopearl_input input_filtre" name=""  v-model="element.values.unit">
                            <option value="K">K</option>
                            <option value="M">M</option>
                            <option value="Bn">Bn</option>
                          </select>
                          </div>
                      </div>
                      <div class="vselect_container  col-12 col-lg-6" >
                        <div class="zone_input">
                          <div class="">
                            <span class="zone_input_name">Weight</span>
                          </div>
                          <select class="moneyEntryInput innopearl_input input_filtre" name=""  v-model="element.values.devise">
                            <option value="EUR">EUR</option>
                            <option value="USD">USD</option>
                          </select>
                          </div>
                      </div> -->

                    </div>
                  </div>


              </div>

            </div>
          </template>
          </draggable>
          </div>
          <div class="row actions_1">
            <div class="col-12">

              <div class="row criteriaAddingForm">
                <span class="criteria_name">Add a new criteria</span>
                <div class="vselect_container col-12" style="margin-top:20px;" >
                  <div class="zone_input">
                    <div class="">
                      <span class="zone_input_name">Select the taxonomy to add</span>
                    </div>
                    <v-autocomplete v-model="condition_to_add_taxo" :items="this.filterable_taxos" item-title="display_name"  item-value="_id"></v-autocomplete>
                    </div>
                </div>
                <div class="col-12 text-left">

                  <button type="button" @click="addCondition()" :disabled="!condition_to_add_taxo" class="prev_step_btn" name="button">Add this criteria</button>
                </div>


              </div>
            </div>

          </div>
          <div class="row actions" >
            <div class="col-12 text-center">
              <button type="button" @click="close()" class="prev_step_btn" name="button">Cancel</button>

              <button type="button" @click="saveFilter()" class="next_step_btn" name="button">Save this filter</button>
            </div>

          </div>




      </div>
</template>

<script>
import api from '../tools/api';
// import router from '@/router'
  import draggable from 'vuedraggable'
 import { toast } from 'vue-sonner'
export default {
  name :"NewFilter",
  components: {
draggable
  },
  data() {
    return {
      pageInfo: {
        mainTitle : " ",
        subTitle : " ",
      },
      filtre: {
        condition: [],
        filter_name: "",
      },
      condition_to_add_taxo: null,
      filterable_taxos : [],
      value_to_add: [],
      values_list: [],
      addConditionDisplay : true,
    }
  },
  methods:{
    close(){
      this.filtre = {
        condition: [],
        filtre_name: "",
      };
          this.$emit('submited',false);
    },
    saveFilter(){
      console.log(this.filtre);
      if(!this.filtre.filter_name){
        toast.error("Filter name is required ")
      }
      else if(this.filtre.condition.length == 0){
        toast.error("Filter needs at least one condition to be created ")
      }
      else{
        var errors = false;
        this.filtre.condition.forEach((item) => {
          if('min' in item.values){
            if(item.values.min == 0 && item.values.max == 0){
              toast.error("At least one value is required in revenue criteria");
              errors = true;
            }
          }
          else {
            if(item.values.length == 0){
              toast.error("Values can't be empty. Please add values to your criterias or remove them");
              errors = true;
            }
          }

        });

        if(!errors){
          api.post(process.env.VUE_APP_API_URL+"/restrict/create_filtre",
            {
               filtre: this.filtre
           },
           {
             headers: {
                 'Content-Type': 'application/json',
           }
         }).then( (r) => {
           console.log(r);
            toast.success("Filter is added ")
            this.filtre = {
              condition: [],
              filtre_name: "",
            };
              this.$emit('submited', r.data);
         }).catch( (e) => {
           console.log(e);
            toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
       });
        }

      }

    },
    addCondition(){
      var taxonomy = this.filterable_taxos.find(taxo => taxo._id.$oid == this.condition_to_add_taxo.$oid);
      var newCondition = null;
      if(taxonomy.startup_field != "revenue"){
         newCondition = {
            taxonomy_name : taxonomy.startup_field,
            taxonomy_label: taxonomy.display_name,
            values: [],
            operator: "OR",
            weight: 0,
            type : taxonomy.type,
            filterable_taxo_assos: this.condition_to_add_taxo,
            values_list : taxonomy.values
        };
      }
      else{
         newCondition = {
            taxonomy_name : taxonomy.startup_field,
            taxonomy_label: taxonomy.display_name,
            values: {
              min:0,
              max:0,
              unit:"K",
              devise:"EUR"
            },
            operator: "OR",
            weight: 0,
            type : taxonomy.type,
            values_list : []
        };
      }

      this.filtre.condition.push(newCondition);
      this.addConditionDisplay = false;
      this.condition_to_add_taxo = null;
    },
    remove(c){
      console.log(c);
      this.filtre.condition.splice(c,1);
    }
  },
  mounted(){
     this.$store.commit('UPDATE_PAGE_INFO',this.pageInfo)
     api.get(process.env.VUE_APP_API_URL+"/restrict/get_filterable_taxo").then( (r) => {
       // var b = _.merge(this.project.business_challenge, JSON.parse(r.data.business_challenge))
       // console.log();
       // var temp = _.merge(this.candidatespool, r.data)
       console.log("FILTERABLE TAXOS");
       console.log(r.data);
       this.filterable_taxos = r.data;
       // api.get(process.env.VUE_APP_API_URL+"/restrict/get_filtre/"+this.$route.params.filter).then( (r) => {
       //   // var b = _.merge(this.project.business_challenge, JSON.parse(r.data.business_challenge))
       //   // console.log();
       //   // var temp = _.merge(this.candidatespool, r.data)
       //   console.log(r.data);
       //   this.filtre = r.data;
       //   this.filtre.condition.forEach((item) => {
       //      if(item.type == "select"){
       //        if(item.filterable_taxo_assos){
       //          var taxonomy = this.filterable_taxos.find(taxo => taxo._id.$oid == item.filterable_taxo_assos.$oid);
       //          item.values_list = taxonomy.values;
       //        }
       //      }
       //   });

     //   }).catch( (e) => {
     //     console.log(e);
     //      toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
     // });

     }).catch( (e) => {
       console.log(e);
        toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
   });




  },


}
</script>
<style scoped>

.startup_page{
  padding-top:50px;
  padding-bottom: 50px;
  padding: 50px;
}
.content_div{
  /* margin-top:50px;
  margin-bottom: 50px; */
  padding: 50px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
box-shadow: 0px 3px 6px #00000029;
border-radius: 8px;
}
.chart-container {
  position: relative;
}

.next_step_btn,
.next_step_btn:hover{
  background: #3783C5 0% 0% no-repeat padding-box !important;
  box-shadow: 0px 3px 6px #00000029 !important;
  border: 1px solid #3783C5 !important;
  border-radius: 50px;
  opacity: 1;
  padding: 7px 17px;
  color:#FFF;
  margin:5px;
  display:inline-block;
}

.prev_step_btn,
.prev_step_btn:hover{
  border: 1px solid #3783C5;
  border-radius: 50px;
  opacity: 1;
  padding: 7px 17px;
  color:#3783C5;
    margin:5px;
    text-decoration: none;
}

.canvasjs-chart-credit{
  display:none;
}

.chartDiv{
  margin:auto;
}
.col-center{
  text-align: center;
}
.zone_input_name{
  text-align: left;
  font-size: 15px;
  line-height: 18px;
  color: #3783C5;
}
.zone_input_header{
  display:flex;
  gap: 10px;
  align-items: center;
  margin-bottom: 10px;
}
.innopearl_input{
  border: 1px solid #DDDDDD;
border-radius: 2px;
width: 100%;
box-sizing: border-box;
margin-top:10px;
margin-bottom: 20px;
height: 40px;
padding: 5px;
}
@media screen and (max-width: 990px){
.innopearl_input{
  width:100%;
  margin-left:0;
}
}


.customH2{
    color: #3783C5;
    font-size:21px;
    text-transform:uppercase;
    margin-bottom:20px;
}
.v-field--variant-filled .v-field__overlay{
  background:#FFF !important;
}

.dateSelectors{
  display:flex;
  flex-direction:row;
  gap:20px;
}
.dateSelectors label{
  flex:1;
}
.next_step_btn svg{
  margin-right:15px;
}
.filterBtnDiv{
  margin-top:20px;
}
@media screen and (max-width:800px){
  .dateSelectors{
    display:flex;
    flex-direction:column;
    gap:20px;
  }
  .dateSelectors label{
    width:100%;
  }
}
</style>
<style>
.dp__pointer{
  padding-top: 15px !important;
  padding-bottom: 15px !important;
}
.dp__input_icon {
  cursor: pointer;
  position: absolute;
  top: 50%;

  left: 10px !important;
}
.input-slot-image{
  width:100% !important;
  height:100% !important;
  object-fit: contain;
  object-position: center;
  display: block;
}

.criteria{
  padding:20px;
  border:1px solid #ccc;
  margin-top:20px;
  margin-bottom:50px;
  position:relative;
}

 .criteria_name{
   font-size: 17px;
   color: #3783C5;
   line-height: 25px;
   font-weight: 600;
}
@media screen and (max-width:800px){
   .criteria_name{
     margin-top:25px;
   }
}
.criteria .criteria_header{
  display: flex;
  align-content: center;
  align-items: center;
  margin-bottom: 20px;
}
.removeCriteria{
  background:#C63221;
  color:#FFF;
  font-size:12px;
  padding:3px 10px;
  line-height: 28px;
  display:inline-block;
  margin-left:20px;
  position:absolute;
  right:0;
  top:0;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
.criteria :not(input, button){
  cursor:grab;
}
.actions_1{
  margin-bottom: 50px;
}

.criteriaAddingForm{
  border:2px dashed #CCC;
  padding:20px;
  margin-top:20px;

}

.mt20{
margin-top:20px;
}
</style>
